export default __webpack_public_path__ + "0ea43c69a4aad948fe544adfa0c0acb7.svg";